export function createWorkflowRepository(config) {
    const { repository, client: api } = config;
    const PREFIX = ['conversations', 'workflows'];
    return {
        useFind(context, query, options) {
            const result = repository.useQuery({
                staleTime: Infinity,
                ...options,
                queryKey: [...PREFIX, context.principal?.id, query],
                queryFn: async () => {
                    const response = await api.workflowList({});
                    return response.data.data;
                },
            });
            return result;
        },
        useLookup(context, query, options) {
            const result = repository.useQuery({
                staleTime: Infinity,
                ...options,
                queryKey: [...PREFIX, context.principal?.id, query],
                async queryFn() {
                    const response = await api.workflowRetrieve({
                        workflowId: query.id,
                    }, {
                        headers: {
                            Authorization: `Bearer ${context.token}`,
                        },
                    });
                    return response.data;
                },
            });
            return result;
        },
    };
}
//# sourceMappingURL=conversationWorkflowRepository.js.map